import cn from 'classnames';
import styles from '../checkboxList/styles.module.scss';

function ChooseList({ handleChange, childs }: any) {
  return (
    <div className={styles.container}>
      {childs?.map((child: any, i: number) => (
        <div key={i} className={styles.filterSectionSettingContainer}>
          <p
            className={cn(styles.filterSectionSetting, styles.category, {
              [styles.selected]: child.selected,
            })}
            onClick={() => {
              handleChange(childs, child);
            }}
          >
            {child.name}
          </p>
        </div>
      ))}
    </div>
  );
}

export default ChooseList;
